import store from "../store/index";
//--------------
// get reaction
//--------------
export default function getReaction(name) {
  const this_store = store;
  const reactions = this_store.getters["combat/getReactions"]
  let reaction = reactions.find((a) => a.name == name);
  return reaction;
}
